<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Contra Referencia" active>
          <b-row>
            <b-col cols="6">
              <label>Tratamientos Terapeuticos:</label>
              <b-form-textarea v-model="step.contrareferencia.terapeuticos" />
            </b-col>
            <b-col cols="6">
              <label>Tratamiento Recomendado:</label>
              <b-form-textarea v-model="step.contrareferencia.recomendado" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Informe Tecnico">
          <b-card-text>
            <b-row>
              <b-col cols="12">
                <b-form-checkbox 
                  v-model="isInformeTecnicoEnabled" 
                  switch 
                  class="mt-2"
                >
                  Habilitar Informe Técnico
                </b-form-checkbox>
              </b-col>
              <b-col cols="6" v-if="isInformeTecnicoEnabled">
                <label>Fecha informe:</label>
                <flat-pickr 
                  v-model="step.informe.fecha" 
                  placeholder="Fecha" 
                  class="form-control"
                  :config="configdateTimePicker" 
                />
              </b-col>
              <b-col cols="6" v-if="isInformeTecnicoEnabled">
                <label>Dirigido a:</label>
                <b-form-textarea v-model="step.informe.dirigido" />
              </b-col>
              <b-col cols="9" v-if="isInformeTecnicoEnabled">
                <label>Observaciones:</label>
                <b-form-textarea v-model="step.informe.observaciones" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { mapState } from 'vuex';

export default {
  name: 'StepContraReferencia',
  components: {
    flatPickr
  },
  data() {
    return {
      step: {
        contrareferencia: {
          terapeuticos: '',
          recomendado: ''
        },
        informe: {
          fecha: null,
          dirigido: '',
          observaciones: ''
        }
      },
      isInformeTecnicoEnabled: false, // Nueva variable para el switch
      configdateTimePicker: {
        dateFormat: 'd/m/Y',
      },
      isUpdating: false
    }
  },
  computed: {
    ...mapState({
      stModalCompletarDerivacion: state => state.derivaciones.modalCompletarDerivacion
    })
  },
  watch: {
    stModalCompletarDerivacion: {
      deep: true,
      handler(newValue) {
        const tipoDerivacion = newValue.dataForm?.tipoDerivacion?.value;
        this.isVisibleStepContraReferencia = (tipoDerivacion === "4" || tipoDerivacion === "3");
        console.log('tipoDerivacion:', tipoDerivacion, 'isVisibleStepContraReferencia:', this.isVisibleStepContraReferencia);
      }
    },
    'stModalCompletarDerivacion.zData': {
      immediate: true,
      handler(newValue) {
        if (this.isUpdating) return;
        if (newValue) {
          this.isUpdating = true;
          this.step.contrareferencia = newValue.contrareferencia || { terapeuticos: '', recomendado: '' };
          this.step.informe = newValue.informaciontecnica || { fecha: null, dirigido: '', observaciones: '' };
          this.isInformeTecnicoEnabled = !!newValue.informaciontecnica; // Habilitar switch si hay datos
          console.log('Actualizando step desde zData:', JSON.stringify(this.step, null, 2));
          this.$store.commit("setModalCompletarDerivacion", { 
            stepContraReferencia: this.step,
            isInformeTecnicoEnabled: this.isInformeTecnicoEnabled // Guardar estado del switch
          });
          this.$nextTick(() => {
            this.isUpdating = false;
          });
        }
      }
    },
    step: {
      deep: true,
      handler(newValue) {
        if (this.isUpdating) return;
        console.log('Propagando step al store:', JSON.stringify(newValue, null, 2));
        this.isUpdating = true;
        this.$store.commit("setModalCompletarDerivacion", { 
          stepContraReferencia: newValue,
          isInformeTecnicoEnabled: this.isInformeTecnicoEnabled
        });
        this.$nextTick(() => {
          this.isUpdating = false;
        });
      }
    },
    isInformeTecnicoEnabled(newValue) {
      if (!newValue) {
        // Limpiar datos del informe técnico si se deshabilita
        this.step.informe = { fecha: null, dirigido: '', observaciones: '' };
      }
      this.$store.commit("setModalCompletarDerivacion", { 
        stepContraReferencia: this.step,
        isInformeTecnicoEnabled: newValue
      });
    }
  },
  created() {
    console.log('created - zData:', this.stModalCompletarDerivacion.zData);
  }
}
</script>